import React, { Component } from 'react'
import { connect } from 'react-redux'

import CamaraView from '../components/CamaraView'
import { initialState } from '../reducers'

class Camara extends Component {
  render () {
    const { position, huds, rotacion } = this.props.state
    return <CamaraView position={position} rotacion={rotacion} huds={huds} />
  }
}

const mapStateToProps = (state) => {
  return {
    state: state.vista3d.camara || initialState.camara
  }
}

const withRedux = connect(mapStateToProps)

export default withRedux(Camara)
